import React from 'react';
import {Modal} from 'react-bootstrap';

const DeleteCongressModal = (props)=>{
    const {congress, onHide, onConfirm} = props;
    return (
        <Modal
            show={true}
            onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Eliminar congreso</Modal.Title>
            </Modal.Header>
            <Modal.Body >
                <p>¿Estás seguro que deseas eliminar el congreso&nbsp;<strong>{congress.name}</strong>?</p>
                <p>Esta acción no se puede deshacer.</p>
            </Modal.Body>
            <Modal.Footer>
                <button onClick={ onHide } className='btn btn-primary pull-left'>Cancelar</button>
                <button className='btn btn-danger' onClick={ ()=>onConfirm( congress ) }>Eliminar</button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteCongressModal;


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/Congresses/components/DeleteCongressModal/index.jsx